export default __webpack_public_path__ + "static/media/03AW2NOV65.b10ce17d.jpg";